import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/home/client";

export default class HomeClientsService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
